import * as React from 'react';

import classNames from 'classnames';

interface IFileUploadProps {
	fileValidationRegex: string;
	hasName?: boolean;
	fileLabel?: string;
	isDisabled?: boolean;
	onFileInputChange?: (file: File, isValid: boolean) => void;
}

interface IFileUploadState {
	fileName: string;
}

export default class FileUpload extends React.Component<
	IFileUploadProps,
	IFileUploadState
> {
	constructor(props) {
		super(props);
		this.state = {
			fileName: '',
		};
	}

	public onFileInputChange = (event?) => {
		const file: File = (event.target as HTMLInputElement).files[0];
		const fileName = file.name;

		const regex = new RegExp(this.props.fileValidationRegex);
		const isValid = regex.test(fileName);

		this.setState({
			...this.state,
			fileName,
		});

		if (this.props.onFileInputChange) {
			this.props.onFileInputChange(file, isValid);
		}
	};

	public render() {
		const { hasName, fileLabel, isDisabled } = this.props;

		const classes = classNames(
			'file',
			hasName && 'has-name',
			isDisabled && 'is-disabled'
		);

		return (
			<div className={classes}>
				<label className="file-label">
					<input
						className="file-input"
						type="file"
						onChange={this.onFileInputChange}
						disabled={isDisabled}
					/>
					<span className="file-cta">
						<span className="file-icon">
							<i className="fa fa-upload" />
						</span>
						<span className="file-label">
							{fileLabel ? fileLabel : 'Choose a file...'}
						</span>
					</span>
					<span className="file-name">{this.state.fileName}</span>
				</label>
			</div>
		);
	}
}
